import React, { Component } from "react";
import TabelaEmpresas from "./TabelaEmpresas";

class Reprovados extends Component {
  render() {
    return <TabelaEmpresas dados={this.props.payload} mostrarAcoes={false} />;
  }
}

export default Reprovados;
